// var Shopify = Shopify || {};

// // ---------------------------------------------------------------------------
// // Money format handler (with dynamic currency support)
// // ---------------------------------------------------------------------------
// Shopify.currency = Shopify.currency || {{ shop.currency | json }};
// var useCurrencyCode = {{ settings.currency_code_enabled | json }};
// Shopify.money_format = (useCurrencyCode ? {{ shop.money_with_currency_format | json }} : {{ shop.money_format | json }}) || "${{amount}}"; // derive from shop settings

// Shopify.formatMoney = function(cents, format, currency) {
//   try {
//     // Coerce cents to number
//     if (typeof cents === "string") {
//       cents = cents.replace(/[^0-9.-]/g, "");
//       cents = parseFloat(cents);
//     }
//     if (isNaN(cents) || cents === null) {
//       cents = 0;
//     }

//     var value = "";
//     var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

//     // Ensure a valid format string
//     var formatString = format || this.money_format || "${{amount}}";
//     if (typeof formatString !== "string" || !placeholderRegex.test(formatString)) {
//       formatString = "${{amount}}";
//     }

//     function defaultOption(opt, def) {
//       return typeof opt === "undefined" ? def : opt;
//     }

//     function formatWithDelimiters(number, precision, thousands, decimal) {
//       precision = defaultOption(precision, 2);
//       thousands = defaultOption(thousands, ",");
//       decimal = defaultOption(decimal, ".");

//       if (isNaN(number) || number === null) {
//         return "0";
//       }

//       number = (number / 100.0).toFixed(precision);

//       var parts = number.split("."),
//         dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
//         centsPart = parts[1] ? decimal + parts[1] : "";

//       return dollars + centsPart;
//     }

//     var placeholderMatch = formatString.match(placeholderRegex);
//     if (!placeholderMatch) return (cents / 100).toFixed(2);

//     switch (placeholderMatch[1]) {
//       case "amount":
//         value = formatWithDelimiters(cents, 2);
//         break;
//       case "amount_no_decimals":
//         value = formatWithDelimiters(cents, 0);
//         break;
//       case "amount_with_comma_separator":
//         value = formatWithDelimiters(cents, 2, ".", ",");
//         break;
//       case "amount_no_decimals_with_comma_separator":
//         value = formatWithDelimiters(cents, 0, ".", ",");
//         break;
//       default:
//         value = formatWithDelimiters(cents, 2);
//         break;
//     }

//     // Replace optional {{currency}}
//     var currencyCode = currency || Shopify.currency || {{ shop.currency | json }} || "";
//     if (formatString.indexOf("{{currency}}") !== -1) {
//       formatString = formatString.replace("{{currency}}", currencyCode);
//     }

//     return formatString.replace(placeholderRegex, value);
//   } catch (e) {
//     // Safe fallback to plain amount
//     try {
//       return (Number(cents) / 100).toFixed(2);
//     } catch (_) {
//       return "0.00";
//     }
//   }
// };
var Shopify = Shopify || {};

// ---------------------------------------------------------------------------
// Money format handler (with dynamic currency support)
// ---------------------------------------------------------------------------
Shopify.money_format = "$"; // default format

Shopify.formatMoney = function(cents, format, currency) {
//   if (typeof cents === "string") {
//     cents = cents.replace(".", "");
//   }

  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt === "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  var placeholderMatch = formatString.match(placeholderRegex);
  if (!placeholderMatch) return cents;

  switch (placeholderMatch[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  // Replace  if provided
  if (currency) {
    formatString = formatString.replace("", currency);
  } else if (Shopify.currency) {
    formatString = formatString.replace("", "");
  } else {
    formatString = formatString.replace("", "");
  }

  return formatString.replace(placeholderRegex, value);
};
